import React, { useEffect, useState } from 'react';

import './_YatDivider.scss';

interface YatDividerProps {
    marginTop?: number;
    marginBottom?: number;
}
export const YatDivider = ({ marginTop, marginBottom }: YatDividerProps) => {
    const [style, setStyle] = useState({});
    useEffect(() => {
        setStyle({ marginTop, marginBottom });
    }, [marginTop, marginBottom]);
    return <div style={style} className="yat-divider" />;
};
